import { call, put, takeEvery } from "redux-saga/effects"
import { getInterviewCandidateList } from "../../../../helpers/fakebackend_helper"
import { GET_CANDIDATE_INTERVIEW_LIST_DETAILS } from './actionTypes'
import { getCandidateInterviewListFail, getCandidateInterviewListSuccess } from './actions'

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

function* getCandidateInterviewHandler({payload: {jsonData}}){
 
  let url = constClass.REST_API_CANDIDATE_INTERVIEW+`?code=${jsonData.code}${jsonData?.jobId  ? `&jobId=${jsonData.jobId}`: ""}&page=${jsonData.pageNumber}&pageSize=${jsonData.pageSize}`
   
  if(jsonData.sort !== undefined && jsonData.Sort !== null){
       url = url+jsonData.sort
  }

  if(jsonData.keyword !== undefined && jsonData.keyword  !== null && jsonData.keyword  !== "" ){
    url = url+jsonData.keyword
}
let extentedUrl=""
if(jsonData.filter !== undefined && jsonData.filter !== null && jsonData.filter !== "" && jsonData.filter.length > 0){
   jsonData.filter.map(eachObject=>{extentedUrl +=  encodeURIComponent(eachObject.filterName)+"="+encodeURIComponent(`${[eachObject.value]}`)+"&"    
  }
  )
  extentedUrl = extentedUrl.slice(0, extentedUrl.length-1)

}
  try {
    if(extentedUrl !== ""){
     url =  url+"&"+extentedUrl
    }
    let response = yield call(getInterviewCandidateList, url);
    yield put(getCandidateInterviewListSuccess(response))
  }

  catch (error) {
    yield put(getCandidateInterviewListFail(error))
  }
}




function* CandidateInterviewSaga() {

  yield takeEvery( GET_CANDIDATE_INTERVIEW_LIST_DETAILS, getCandidateInterviewHandler)

}

export default CandidateInterviewSaga